import Vue from 'vue';
import { gsap } from 'gsap';
var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');

Vue.component('productions-filter-component', {
    props: {

    },
    data() {
        return {
            iso: null,
            search: '',
            gotHeighestBlock: false,
            activeTag: '',
        }
    },

    mounted() {
        var menu = document.querySelector('.agenda-filter-desktop')
        var menuPosition = menu.offsetTop - menu.scrollTop + menu.clientTop;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset + 106 >= menuPosition) {
                menu.classList.add('fixed');
            } else {
                menu.classList.remove('fixed');
            }
        });

        this.$nextTick(() => {
            this.initGrid();
        });

        window.addEventListener('resize', () => {
            this.getHeighestBlock();
        })
        
        
    },

    watch: {
        search: function (val) {
            if (val) {
                this.iso.arrange({ filter: function(obj) {
                    let content = obj.querySelector('.block__title').innerHTML;
                    content += ' '+ obj.querySelector('.block__text').innerHTML;
                    const searchReg = new RegExp( val, 'gi' );
                    return content.match(searchReg);
                } });
            } else {
                this.iso.arrange({ filter: () => { return true }});
            }
        },
        gotHeighestBlock: function(val) {
            setTimeout(() => {
                this.initIsotope();
            }, 500);
        }

    },

    methods: {
        initGrid() {
            this.blocks = this.$el.querySelectorAll('.block');

            this.grid = this.$el.querySelector('.productions-grid') || this.$el;

            new imagesLoaded( this.grid, () => {
                this.getHeighestBlock();
            });
        },

        getHeighestBlock() {
            gsap.set('.block', {height: 'auto'})
            
            setTimeout(() => {
            this.heighestBlock = this.blocks[0]
            for (let index = 0; index < this.blocks.length; index++) {
                const element = this.blocks[index];
                if(element.getBoundingClientRect().height > this.heighestBlock.getBoundingClientRect().height && !element.classList.contains('block--width2')) {
                    this.heighestBlock = this.blocks[index]
                }
                console.log(this.heighestBlock.getBoundingClientRect().height)
            }

            gsap.to('.block', {height: this.heighestBlock.getBoundingClientRect().height})

        
            this.gotHeighestBlock = !this.gotHeighestBlock
        }, 200);
            
        },

        initIsotope() {
            this.iso = new Isotope(this.grid, {
                masonry: {
                    columnWidth: '.grid-sizer',
                    gutter: '.gutter-sizer',
                    // horizontalOrder: true
                },
                itemSelector: '.block',
                percentPosition: true
            });
        },
        toggleMobileFilter(event) {
            const element = event.currentTarget;
            const collapse = document.querySelector('.filter-overlay');

            if (collapse.classList.contains('open')) {
                element.classList.remove('collapsed');
                collapse.classList.remove('open')
                gsap.to(collapse, { height: 0, opacity: 0, display: 'none' });
                return;
            }

            element.classList.add('collapsed');
            collapse.classList.add('open');
            gsap.to(collapse, { display: 'block', height: '100%', opacity: 1 });
        },

        /**
         * Filter isotope on given tag slug.
         * 
         * @param tag
         */
        filterOnTag(e, tag) {
            this.iso.arrange({ filter: '.'+ tag });

            // delete all active tags
            const activeElements = this.$el.querySelectorAll('.active');
            for (var i = 0; i < activeElements.length; i++) {
                activeElements[i].classList.remove('active')
            }

            // check if user clicks a new tag or the same, if it's the same stop filtering and show all otherwise set new tag as active
            if(this.activeTag !== tag) {
                this.activeTag = tag;
                gsap.to(e.target, {classList: `${e.target.classList} active`})

            } else {
                this.activeTag = ''
                this.iso.arrange({ filter: '*' });
            }
        }
    },

    beforeDestroy() {

    }
});
